export default __webpack_public_path__ + "static/media/MidSteppes.2595da91.jpg";